export const PREFIX = "[AUDIENCES_API]";


export const GUESTS_FRIENDS_FETCH = `${PREFIX}.GuestsFriendsFetch`;
export const GUESTS_FRIENDS_FETCH_SUCCESS = `${GUESTS_FRIENDS_FETCH}Success`;
export const GUESTS_FRIENDS_FETCH_ERROR = `${GUESTS_FRIENDS_FETCH}Error`;

export const VISITORS_FETCH = `${PREFIX}.VisitorsFetch`;
export const VISITORS_FETCH_SUCCESS = `${VISITORS_FETCH}Success`;
export const VISITORS_FETCH_ERROR = `${VISITORS_FETCH}Error`;

export const WEDDINGS_FETCH = `${PREFIX}.WeddingsFetch`;
export const WEDDINGS_FETCH_SUCCESS = `${WEDDINGS_FETCH}Success`;
export const WEDDINGS_FETCH_ERROR = `${WEDDINGS_FETCH}Error`;

export const TEAM_FETCH = `${PREFIX}.TeamFetch`;
export const TEAM_FETCH_SUCCESS = `${TEAM_FETCH}Success`;
export const TEAM_FETCH_ERROR = `${TEAM_FETCH}Error`;

export const RANDOM_PHOTOS_FETCH = `${PREFIX}.RandomPhotosFetch`;
export const RANDOM_PHOTOS_FETCH_SUCCESS = `${RANDOM_PHOTOS_FETCH}Success`;
export const RANDOM_PHOTOS_FETCH_ERROR = `${RANDOM_PHOTOS_FETCH}Error`;

export const SEASONAL_PHOTOS_FETCH = `${PREFIX}.SeasonalPhotosFetch`;
export const SEASONAL_PHOTOS_FETCH_SUCCESS = `${SEASONAL_PHOTOS_FETCH}Success`;
export const SEASONAL_PHOTOS_FETCH_ERROR = `${SEASONAL_PHOTOS_FETCH}Error`;

export const CURRENT_PHOTOS_FETCH = `${PREFIX}.CurrentPhotosFetch`;
export const CURRENT_PHOTOS_FETCH_SUCCESS = `${CURRENT_PHOTOS_FETCH}Success`;
export const CURRENT_PHOTOS_FETCH_ERROR = `${CURRENT_PHOTOS_FETCH}Error`;

export const BROADCAST_WORTHY_QUOTES_FETCH = `${PREFIX}.QuotesFetch`;
export const BROADCAST_WORTHY_QUOTES_FETCH_SUCCESS = `${BROADCAST_WORTHY_QUOTES_FETCH}Success`;
export const BROADCAST_WORTHY_QUOTES_FETCH_ERROR = `${BROADCAST_WORTHY_QUOTES_FETCH}Error`;

export const BROADCAST_POPULAR_STORIES_FETCH = `${PREFIX}.BroadcastPopularStoriesFetch`;
export const BROADCAST_POPULAR_STORIES_FETCH_SUCCESS = `${BROADCAST_POPULAR_STORIES_FETCH}Success`;
export const BROADCAST_POPULAR_STORIES_FETCH_ERROR = `${BROADCAST_POPULAR_STORIES_FETCH}Error`;

export const BROADCAST_WORTHY_STORIES_FETCH = `${PREFIX}.BroadcastWorthyStoriesFetch`;
export const BROADCAST_WORTHY_STORIES_FETCH_SUCCESS = `${BROADCAST_WORTHY_STORIES_FETCH}Success`;
export const BROADCAST_WORTHY_STORIES_FETCH_ERROR = `${BROADCAST_WORTHY_STORIES_FETCH}Error`;


export function guestsAndFriends(propertyUUID) {
    return (dispatch, getState, { $http, environment }) => {
        dispatch({ type: GUESTS_FRIENDS_FETCH });
        return $http.get(`${environment.apiBaseUrl}/${propertyUUID}/audiences/${propertyUUID}/guests`)
            .then(response => {
                dispatch({ type: GUESTS_FRIENDS_FETCH_SUCCESS, payload: response.data });
                return response.data;
            }, error => {
                dispatch({ type: GUESTS_FRIENDS_FETCH_ERROR, payload: error });
                throw GUESTS_FRIENDS_FETCH_ERROR;
            })
    }
}

export function visitors(propertyUUID) {
    return (dispatch, getState, { $http, environment }) => {
        dispatch({ type: VISITORS_FETCH });
        return $http.get(`${environment.apiBaseUrl}/${propertyUUID}/audiences/${propertyUUID}/visitors`)
            .then(response => {
                dispatch({ type: VISITORS_FETCH_SUCCESS, payload: response.data });
                return response.data;
            }, error => {
                dispatch({ type: VISITORS_FETCH_ERROR, payload: error });
                throw VISITORS_FETCH_ERROR;
            })
    }
}

export function weddings(propertyUUID) {
    return (dispatch, getState, { $http, environment }) => {
        dispatch({ type: WEDDINGS_FETCH });
        return $http.get(`${environment.apiBaseUrl}/${propertyUUID}/audiences/${propertyUUID}/theme/1`)
            .then(response => {
                dispatch({ type: WEDDINGS_FETCH_SUCCESS, payload: response.data });
            }, error => {
                dispatch({ type: WEDDINGS_FETCH_ERROR, payload: error });
                throw WEDDINGS_FETCH_ERROR;
            })
    }
}

export function team(propertyUUID) {
    return (dispatch, getState, { $http, environment }) => {
        dispatch({ type: TEAM_FETCH });
        return $http.get(`${environment.apiBaseUrl}/${propertyUUID}/audiences/${propertyUUID}/theme/2`)
            .then(response => {
                dispatch({ type: TEAM_FETCH_SUCCESS, payload: response.data });
                return response.data;
            }, error => {
                dispatch({ type: TEAM_FETCH_ERROR, payload: error });
                throw TEAM_FETCH_ERROR;
            })
    }
}

export function randomPhotos(propertyUUID, page) {
    return (dispatch, getState, { $http, environment }) => {
        dispatch({ type: RANDOM_PHOTOS_FETCH });
        return $http.get(`${environment.apiBaseUrl}/${propertyUUID}/photos/broadcast?propertyUUID=${propertyUUID}&theme=0&pageSize=3&pageNumber=${page}`)
            .then(response => {
                dispatch({ type: RANDOM_PHOTOS_FETCH_SUCCESS, payload: response.data });
                return response.data;
            }, error => {
                dispatch({ type: RANDOM_PHOTOS_FETCH_ERROR, payload: error });
                throw RANDOM_PHOTOS_FETCH_ERROR;
            })
    }
}

export function seasonalPhotos(propertyUUID, page, startDate, endDate) {
    return (dispatch, getState, { $http, environment }) => {
        dispatch({ type: SEASONAL_PHOTOS_FETCH });
        return $http.get(`${environment.apiBaseUrl}/${propertyUUID}/photos/broadcast?propertyUUID=${propertyUUID}&theme=0&pageSize=3&pageNumber=${page}&startDate=${startDate}&endDate=${endDate}`)
            .then(response => {
                dispatch({ type: SEASONAL_PHOTOS_FETCH_SUCCESS, payload: response.data });
                return response.data;
            }, error => {
                dispatch({ type: SEASONAL_PHOTOS_FETCH_ERROR, payload: error });
                throw SEASONAL_PHOTOS_FETCH_ERROR;
            })
    }
}

export function currentCampaignPhotos(propertyUUID, page) {
    return (dispatch, getState, { $http, environment }) => {
        dispatch({ type: CURRENT_PHOTOS_FETCH });
        return $http.get(`${environment.apiBaseUrl}/${propertyUUID}/photos/broadcast?propertyUUID=${propertyUUID}&theme=0&pageSize=3&pageNumber=${page}&isCurrent=true`)
            .then(response => {
                dispatch({ type: CURRENT_PHOTOS_FETCH_SUCCESS, payload: response.data });
                return response.data;
            }, error => {
                dispatch({ type: CURRENT_PHOTOS_FETCH_ERROR, payload: error });
                throw CURRENT_PHOTOS_FETCH_ERROR;
            })
    }
}

export function getBroadcastWorthyStories(propertyUUID, startDate, endDate) {
    return (dispatch, getState, { $http, environment }) => {
        dispatch({ type: BROADCAST_WORTHY_STORIES_FETCH });
        return $http.get(`${environment.apiBaseUrl}/${propertyUUID}/photos/broadcast?propertyUUID=${propertyUUID}&pageSize=3&pageNumber=1&startDate=${startDate}&endDate=${endDate}&isUnshared=true`)
            .then(response => {
                dispatch({ type: BROADCAST_WORTHY_STORIES_FETCH_SUCCESS, payload: response.data });
                return response.data;
            }, error => {
                dispatch({ type: BROADCAST_WORTHY_STORIES_FETCH_ERROR, payload: error });
                throw BROADCAST_WORTHY_STORIES_FETCH_ERROR;
            })
    }
}

export function getMostPopularStories(propertyUUID, startDate, endDate) {
    return (dispatch, getState, { $http, environment }) => {
        dispatch({ type: BROADCAST_POPULAR_STORIES_FETCH });
        return $http.get(`${environment.apiBaseUrl}/${propertyUUID}/photos/broadcast?propertyUUID=${propertyUUID}&pageSize=10&pageNumber=1&orderByPoints=true&startDate=${startDate}&endDate=${endDate}`)
            .then(response => {
                dispatch({ type: BROADCAST_POPULAR_STORIES_FETCH_SUCCESS, payload: response.data });
                return response.data;
            }, error => {
                dispatch({ type: BROADCAST_POPULAR_STORIES_FETCH_ERROR, payload: error });
                throw BROADCAST_POPULAR_STORIES_FETCH_ERROR;
            })
    }
}


export function getBroadcastWorthyQuotes(propertyUUID, isUnshared, startDate, endDate) {
    return (dispatch, getState, { $http, environment }) => {
        dispatch({ type: BROADCAST_WORTHY_QUOTES_FETCH });
        return $http.get(`${environment.apiBaseUrl}/${propertyUUID}/properties/${propertyUUID}/stories/quotes/broadcast?pageNumber=1&pageSize=3&startDate=${startDate}&endDate=${endDate}&isUnshared=${isUnshared}`)
            .then(response => {
                dispatch({ type: BROADCAST_WORTHY_QUOTES_FETCH_SUCCESS, payload: response.data });
                return response.data;
            }, error => {
                dispatch({ type: BROADCAST_WORTHY_QUOTES_FETCH_ERROR, payload: error });
                throw BROADCAST_WORTHY_QUOTES_FETCH_ERROR;
            })
    }
}

const All = {guestsAndFriends, visitors, weddings, team, randomPhotos, seasonalPhotos, currentCampaignPhotos, getBroadcastWorthyStories, getMostPopularStories, getBroadcastWorthyQuotes};
export default All;